import React from 'react';
import Tag from '@amzn/meridian/tag';
import { TagProps } from '@amzn/meridian/tag/tag';
import { formatDistanceToNow } from 'date-fns';

export function HostStatusTag({ status }: { status: string }): JSX.Element {
  let type: TagProps['type'] = 'theme';
  if (status === 'online') {
    type = 'success';
  } else if (status === 'deprecated') {
    type = 'error';
  }
  return <Tag type={type}>{status}</Tag>;
}

export function HostLastUpdatedTag({
  dateModified,
}: {
  dateModified: string;
}): JSX.Element {
  const type: TagProps['type'] = 'theme';
  const d = new Date(dateModified);
  return <Tag type={type}>{formatDistanceToNow(d, { addSuffix: true })}</Tag>;
}
